export const isContactButton = (el: Element): boolean =>
  el.getAttribute("data-is-contact-button") === "true";

export const closeMobileMenu = (
  navList: HTMLElement | null,
  burgerMenu: HTMLElement | null,
  fullPageOverlayControl: HTMLButtonElement | null,
) => {
  navList?.classList.add("hidden");
  burgerMenu?.setAttribute("aria-expanded", "false");
  if (fullPageOverlayControl?.parentElement) {
    import("../../utils").then(({ toggleDialog }) => {
      toggleDialog(fullPageOverlayControl.parentElement, false);
    });
  }
};

